import { render, staticRenderFns } from "./AkHeader.vue?vue&type=template&id=cca909e0&"
import script from "./AkHeader.vue?vue&type=script&lang=js&"
export * from "./AkHeader.vue?vue&type=script&lang=js&"
import style0 from "./AkHeader.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports